/**
 * Transforms an array of field definitions into a nested structure
 * @param {Array} requiredFieldsList - Array of field definitions
 * @returns {Object} Transformed field structure with children grouped
 */
const transformFieldsToNestedStructure = (requiredFieldsList) => {
  // Group fields by their top-level key (either 'key' or 'parent')
  const groupedFields = {};

  requiredFieldsList.forEach((field) => {
    if (field.key) {
      // Direct field with key
      if (!groupedFields[field.key]) {
        groupedFields[field.key] = {
          fields: [],
          children: {},
        };
      }
      groupedFields[field.key].fields = field.value;
    } else if (field.parent && field.fieldName) {
      // Nested field with parent and fieldName
      if (!groupedFields[field.parent]) {
        groupedFields[field.parent] = {
          fields: [],
          children: {},
        };
      }
      groupedFields[field.parent].children[field.fieldName] = {
        fields: field.value,
      };
    }
  });

  return groupedFields;
};

export { transformFieldsToNestedStructure };
